import { ROLES } from '@/constants/roles';

export const partners = {
  // path: '/partners/invitations',
  meta: {
    title: 'Партнеры',
    icon: 'mdi-account-outline',
    accessList: [ROLES.expert],
    children: [
      {
        text: 'Приглашения',
        to: '/partners/invitations',
        icon: 'mdi-email-fast-outline',
        visibleFor: [ROLES.expert],
      },
      {
        text: 'Активные партнеры',
        to: '/partners/active',
        icon: 'mdi-account-star-outline',
        visibleFor: [ROLES.expert],
      },
    ],
  },

};
export default [
  partners,
  {
    path: '/partners/invitations',
    name: 'partners-invitations',
    component: () => import('./views/partners-invitations/index.vue'),
    meta: {
      title: 'Приглашения',
      accessList: [ROLES.expert],
    },
  },
  {
    path: '/partners/active',
    name: 'partners-active',
    component: () => import('./views/partners-active/index.vue'),
    meta: {
      title: 'Активные партнеры',
      accessList: [ROLES.expert],
    },
  },
];
